import React from "react";

function Footer() {
return (
    <footer className="footer">
        <div className="socials">
            <a href="https://discord.com/users/1015696434818977833" target="_blank" rel="noopener noreferrer">Discord</a>
            <a href="https://www.instagram.com/76mikus/" target="_blank" rel="noopener noreferrer">Instagram</a>
        </div>
    </footer>
);
}

export default Footer;
